import styles from '../node.module.css'

export interface NodeFooterProps {
  children: React.ReactNode
}

export const NodeFooter = ({ children }: NodeFooterProps) => {
  return <div className={styles.footer}>{children}</div>
}
